import { rareResources, archiveSpecials } from "@/mocks/manga";

const rareStatus: Record<string, string> = {
  可补档: "bg-accent-100 text-accent-700",
  限量: "bg-primary-100 text-primary-700",
  整理中: "bg-secondary-100 text-secondary-800",
};

export default function RareArchive() {
  return (
    <section id="rare" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-2">
          <p className="text-xs font-semibold tracking-widest text-accent-600">RARE &amp; VINTAGE</p>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">绝版资源 · 一页难求</h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            从旧书店、收藏者与原刊渠道找回的绝版扫描件，逐页修复还原当年的纸刊质感。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {rareResources.map((item) => (
            <article
              key={item.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="mb-3 flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-book-2-line text-lg"></i>
                </span>
                <span
                  className={`rounded-full px-2.5 py-1 text-xs font-semibold ${rareStatus[item.status] ?? "bg-background-200 text-foreground-700"}`}
                >
                  {item.status}
                </span>
              </div>
              <h3 className="font-heading text-base text-foreground-950">{item.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span>{item.source}</span>
                <span>{item.year}</span>
              </div>
            </article>
          ))}
        </div>

        <div id="archive" className="mt-12 scroll-mt-24">
          <div className="mb-6 flex flex-col gap-2">
            <p className="text-xs font-semibold tracking-widest text-secondary-600">ARCHAEOLOGY</p>
            <div className="flex flex-wrap items-end justify-between gap-3">
              <div>
                <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">经典老番考古专题</h2>
                <p className="mt-2 max-w-xl text-sm text-foreground-600">
                  追溯那些被时间遗忘的漫画与漫画家，记录怀旧漫背后的年代故事。
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {archiveSpecials.map((item) => (
              <article
                key={item.id}
                className="group overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={item.img}
                    alt={`${item.title}经典老番考古专题配图`}
                    className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-base text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="text-xs text-foreground-500">{item.posts} 篇考古资料</span>
                    <a
                      href="#request"
                      className="inline-flex items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-700"
                    >
                      阅读专题 <i className="ri-arrow-right-line text-base"></i>
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}